import { keys, isNil, isEmpty, equals, includes } from 'ramda';
import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';

const validationSchema = {
  nullable: (check, value) => {
    if (check) return true;
    return !isNil(value);
  },
  canBeZero: (check, value) => {
    if (check) return true;
    return value !== 0;
  },
  canBeEmpty: (check, value) => {
    if (check) return true;
    return !isEmpty(value);
  },
  canBeNegative: (check, value) => {
    if (check) return true;
    return value >= 0;
  },
};

export const validate = (validations, value) => {
  return keys(validations).reduce(
    ({ isValid }, rule) => {
      if (!isValid) return { isValid };
      return { isValid: validationSchema[rule](validations[rule], value) };
    },
    { isValid: true },
  );
};

export const compareQuestionValues = (first, second, rule) => {
  const mapper = {
    equal: equals,
    notEqual: (a, b) => a !== b,
    greaterThanOrEqual: (a, b) => a >= b,
  };

  return mapper[rule](first, second);
};

export const QUESTION_TYPES = {
  input: 'input',
  select: 'select',
  priceTarget: 'priceTarget',
  downPaymentTarget: 'downPaymentTarget',
  annualGrossIncome: 'annualGrossIncome',
  location: 'location',
  textField: 'textField',
  mortgageBalance: 'mortgageBalance',
  cashOutAmount: 'cashOutAmount',
  flow: 'flow',
  cashOutSelect: 'cashOutSelect',
};

export const MORTAGAGE_FLOW_OPTIONS = [
  { label: 'Buy a Home', value: 'purchase' },
  { label: 'Refinance a Home', value: 'refinance' },
];

export default new Presenter(
  {
    questionId: PropTypes.number,
    surveyValueFields: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    inputLabel: PropTypes.string,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
    placeholder: PropTypes.string,
    validations: PropTypes.shape(),
    depends: PropTypes.arrayOf(PropTypes.shape()),
  },
  {
    isSelectQuestionType(type) {
      return includes(type, [QUESTION_TYPES.select, QUESTION_TYPES.flow, QUESTION_TYPES.cashOutSelect]);
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/MortgageSurveyQuestionPresenter.js